export enum UploadStatusName {
  PENDING = 'pending',
  SUCCESS = 'success',
  FAILED = 'failed',
  DELETED = 'deleted',
  NOT_EXPECTED = 'not_expected',
}
